import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { resetAttractionImage } from '~/services/AttractionsService';

import { attractionQueryKeys } from './attractionQueryKeys';

/**
 * Resets the hero image to auto-selected and invalidates cache.
 */
export function useResetAttractionImage() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (attractionId: string) => {
      return await resetAttractionImage(attractionId);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: attractionQueryKeys.all });
      enqueueSnackbar('Hero image reset to auto', { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Error resetting image: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
